import React, { useContext, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { DocumentationDeliveryInformation } from "../../model/DocumentationDeliveryType";
import { ZahtjevContext } from "../../common/context/ZahtjevProvider";
import { CreateZahtjevDostavaDokumentacijeRequest, useUpdateDocumentationDelivery } from "../../api/RegistrationApi";
import { useNotification } from "../../common/context/NotificationProvider";
import { Button } from "../common/Button";
import { Card } from "../common/Card";
import { Tooltip } from "../common/Tooltip";
import { ERROR_MESSAGE_NOTIFICATION } from "../../common/constants/notificationConstants";
import { DOCUMENTATION_DELIVERY_INFORMATION_STATUS } from "../../common/constants/navigationConstants";
import ecoImage from "../../images/OTP-icon-72x72-social-and-cultural-awareness.svg"
import { useTranslation } from "react-i18next";

function mapDocumentationDeliveryInformationToCreateZahtjevDostavaDokumentacijeRequest(): CreateZahtjevDostavaDokumentacijeRequest {
    return {
        kanalKredPrek: "E",
        kanalOpciDok: "E",
        kanalRacKart: "E",
    }
}

const DocumentationDeliveryPage = () => {
    const { t } = useTranslation();
    const {
        documentationDeliveryCallback,
        getZahtjevId,
        restoreContext,
        getStatus,
    } = useContext(ZahtjevContext);
    const {
        mutate: updateDocumentationDeliveryMutation,
    } = useUpdateDocumentationDelivery(getZahtjevId());
    const currentStatus = getStatus();
    const pageStatus = DOCUMENTATION_DELIVERY_INFORMATION_STATUS;
    const navigate = useNavigate();
    const { notify } = useNotification();

    const documentationDeliveryInformation: DocumentationDeliveryInformation = {
        kanalRacKart: {
            id: "E",
            vrijednost: "E-mail"
        },
        kanalKredPrek: {
            id: "E",
            vrijednost: "E-mail"
        },
        kanalOpciDok: {
            id: "E",
            vrijednost: "E-mail"
        }
    };


    const handleSubmit = () => {
        const request = mapDocumentationDeliveryInformationToCreateZahtjevDostavaDokumentacijeRequest();

        updateDocumentationDeliveryMutation(request, {
            onSuccess: () => {
                documentationDeliveryCallback(documentationDeliveryInformation);
                navigate('/marketing-consent');
            },
            onError: () => {
                notify(ERROR_MESSAGE_NOTIFICATION, "error");
            }
        });
    };

    const handleReturn = () => {
        navigate('/political-exposure')
    }

    useEffect(() => {
        restoreContext(pageStatus);
    }, []);

    return (
      <Card title={<div className="flex items-center"><span>{t("documentation-delivery-page.title")}</span><Tooltip
        text={t("documentation-delivery-page.tooltip")} className="ml-2 cursor-help" iconSize="medium"/></div>}
            isLoading={parseInt(currentStatus) < parseInt(pageStatus)}
            bodyClassName="md:w-full">
          <img
            src={ecoImage}
            width={160}
            height={160}
            alt="Ecology image"
          />
          <div className="mt-4 space-y-4">
              <p>{t("documentation-delivery-page.description")}</p>
          </div>

          <div className="mt-10 text-center md:text-left">
              <Button
                type="button"
                onClick={handleReturn}
                text={t("common.button-previous")}
                variant="secondary"
                disabled={false}
              />
              <Button
                onClick={handleSubmit}
                text={t("common.button-next")}
              />
          </div>
      </Card>
    );
};

export default DocumentationDeliveryPage;
